import React, { useState, useEffect } from "react";
import { Save } from "lucide-react";

export default function VisionValuesForm({
  visionData,
  setVisionData,
  onSave,
}) {
  const [formData, setFormData] = useState({
    visionTitle:
      visionData?.vision_title || visionData?.visionTitle || "Our Vision",
    visionText:
      visionData?.vision_text ||
      visionData?.visionText ||
      "At HPR Infra, our vision is to be the beacon of innovation and excellence in the real estate landscape, setting new standards for modern living in South India and beyond. With a legacy built on trust, integrity, and forward-thinking, HPR Infra is dedicated to shaping the future, where every project becomes a testament to our commitment to creating spaces that inspire and endure.",
  });

  // Sync when visionData changes
  useEffect(() => {
    if (visionData) {
      setFormData({
        visionTitle:
          visionData.vision_title || visionData.visionTitle || "Our Vision",
        visionText:
          visionData.vision_text ||
          visionData.visionText ||
          "At HPR Infra, our vision is to be the beacon of innovation and excellence in the real estate landscape, setting new standards for modern living in South India and beyond. With a legacy built on trust, integrity, and forward-thinking, HPR Infra is dedicated to shaping the future, where every project becomes a testament to our commitment to creating spaces that inspire and endure.",
      });
    }
  }, [visionData]);

  const handleVisionChange = (field, value) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: value };
      if (setVisionData) setVisionData(updated);
      return updated;
    });
  };

  const handleSave = () => {
    if (onSave) {
      onSave({
        visionTitle: formData.visionTitle,
        visionText: formData.visionText,
      });
    }
    alert("Vision saved successfully!");
  };

  return (
    <section className="bg-white rounded-xl shadow p-8 mb-10">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-blue-700">Vision</h2>
        <button
          onClick={handleSave}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
        >
          <Save size={18} /> Save
        </button>
      </div>

      {/* Vision Title */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Vision Title
        </label>
        <input
          type="text"
          value={formData.visionTitle}
          onChange={(e) => handleVisionChange("visionTitle", e.target.value)}
          className="w-full border rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-blue-400 outline-none"
          placeholder="e.g., Our Vision"
        />
      </div>

      {/* Vision Description */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Vision Description
        </label>
        <textarea
          value={formData.visionText}
          onChange={(e) => handleVisionChange("visionText", e.target.value)}
          className="w-full border rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-blue-400 outline-none h-32"
          placeholder="Write your company vision here..."
        />
      </div>
    </section>
  );
}
